import axios from 'axios';
import {
  SERVER_ERROR_KEY,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';

import httpErrors, { HttpError } from 'http-errors';
import { GuestTokenInput } from '../user-auth-api-input-schema';

export const guestTokenQuery = async ({
  input,
}: {
  input: GuestTokenInput;
}) => {
  try {
    const { url, xApiKey, realm } = input;

    const result = await axios
      .post(
        `${url}/api/v2/login/guest/checkin`,
        {},
        {
          headers: {
            Accept: 'application/json',
            'x-api-key': xApiKey,
            Realm: realm,
          },
        },
      )
      .then(handleAxiosResponse)
      .catch(handleError);
    if (result.hasErrors) {
      const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
        result?.errorMessages?.join('\n'),
      ) as HttpError;
      console.log('result - guest token has errors', result);
      err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
      throw err;
    }

    return result.data.authorisationToken;
  } catch (err: any) {
    console.error(`Error on Guest Token: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};
